import { useAuth0 } from "@auth0/auth0-react";
import { isProductPage, routesFlat } from "@routes";
import clsx from "clsx";

export default function Logout() {
    const { logout, loginWithRedirect } = useAuth0();
    const returnToUrl = isProductPage()
        ? routesFlat.landing
        : window.location.pathname;

    console.log(process.env.REACT_APP_HOME_URL, returnToUrl);
    const handleLogout = () => {
        console.log(
            "Logging out, redirecting to:",
            process.env.REACT_APP_LOGIN_ENABLED
                ? "login"
                : process.env.REACT_APP_HOME_URL,
        );

        localStorage.removeItem("token");
        localStorage.removeItem("username");

        logout({
            returnTo: `${process.env.REACT_APP_HOME_URL}${returnToUrl}`,
            federated: true,
        });

        if (process.env.REACT_APP_LOGIN_ENABLED === "true") {
            loginWithRedirect({
                appState: { returnTo: returnToUrl },
            });
        }
    };

    return (
        <button onClick={handleLogout} className={buttonStyle}>
            Log Out
        </button>
    );
}

export const buttonStyle = clsx(
    "text-xs tracking-wide uppercase z-30 w-auto px-4 py-2 rounded-xl bg-[white] hover:bg-green font-bold",
);
